import { getApiBaseUrl } from "../config/runtimeConfig";
import { ApiError } from "../obras/obrasApi";

const apiBaseUrl = getApiBaseUrl();

// Módulo hand-written para as intervenções pós-venda de uma obra já entregue
// [4.7.2]. Espelha o padrão de workVariations/workVariationsApi.ts: reutiliza o
// ApiError de obrasApi (que humaniza o ProblemDetails do backend) e replica o
// helper request<> mínimo — o request de obrasApi é privado ao módulo, por isso
// não é importável.
async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

export { ApiError };

export interface WorkAfterSalesInterventionDto {
  id: number;
  workId: number;
  description: string;
  interventionDate: string;
  responsible: string | null;
  estimatedValue: number | null;
  actualValue: number | null;
  notes: string | null;
  hasImputedCost: boolean;
  created: string;
  lastModified: string;
}

export interface WorkAfterSalesInterventionsVm {
  interventions: WorkAfterSalesInterventionDto[];
  estimatedTotal: number;
  actualTotal: number;
}

export interface CreateWorkAfterSalesPayload {
  description: string;
  interventionDate: string;
  responsible?: string | null;
  estimatedValue?: number | null;
  actualValue?: number | null;
  notes?: string | null;
}

export type UpdateWorkAfterSalesPayload = CreateWorkAfterSalesPayload;

export function getWorkAfterSales(
  workId: number,
): Promise<WorkAfterSalesInterventionsVm> {
  return request<WorkAfterSalesInterventionsVm>(
    `/api/works/${workId}/after-sales`,
  );
}

export function createWorkAfterSales(
  workId: number,
  payload: CreateWorkAfterSalesPayload,
): Promise<WorkAfterSalesInterventionDto> {
  return request<WorkAfterSalesInterventionDto>(
    `/api/works/${workId}/after-sales`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function updateWorkAfterSales(
  workId: number,
  interventionId: number,
  payload: UpdateWorkAfterSalesPayload,
): Promise<WorkAfterSalesInterventionDto> {
  return request<WorkAfterSalesInterventionDto>(
    `/api/works/${workId}/after-sales/${interventionId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteWorkAfterSales(
  workId: number,
  interventionId: number,
): Promise<void> {
  const response = await fetch(
    `${apiBaseUrl}/api/works/${workId}/after-sales/${interventionId}`,
    { method: "DELETE", credentials: "include" },
  );

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }
}
